export default () => ({
  active: "login",
  show: false,
  toggle(event) {
    if (event && event.detail.active) {
      this.active = event.detail.active;
    }
    //Remove ?login=true from url
    if (this.active === "welcome" && this.show) {
      window.history.replaceState(
        {},
        window.location.pathname,
        window.location.pathname
      );
    }
    this.show = !this.show;
    Grebify.noScroll(this.show);
  },
  toggleActive(active) {
    this.active = active;
  },
  hide() {
    this.show = false;
    Grebify.noScroll(false);
  },
  setSocialLogin() {
    if (!window.shopUrl.includes("jlindebergusa")) {
      let container = document.querySelector('div[name="hiko-container"]');

      if (container && container.hasAttribute("ignore")) {
        // Remove the 'ignore' attribute
        container.removeAttribute("ignore");
      }

      let scriptElement = document.createElement("script");
      scriptElement.type = "text/javascript";
      scriptElement.async = true;
      scriptElement.src =
        "https://apps.hiko.link/js/hiko-auth.js?shop=jlindeberg-europe.myshopify.com";
      window.HIKO.extension = false;
      document.head.appendChild(scriptElement);
    }
  },
});
